import React, {useEffect} from "react";
import * as GC from "../../../../common/common";
import * as CallBackFunctions from "../functions/callBackFunctions";
import $ from "jquery";
import {
    GetAllBySearchAction,
    InputDataActivityFlowAction,
    StartActivityFlowAction
} from "../../../../../api/omnimap/omnimapActions";
import {GetSelected} from "../../../../common/tableHandler/manipulateTable";


function PlaatsInWerkorder() {
    useEffect(() => {
        $("#performance_plaats_in_werkorder").on("show.bs.modal", prepare)
    })

    const prepare = () => {
        const model = {
            "content": [
                {
                    "key": "algemeen-actief",
                    "and_or": "AND",
                    "values": [
                        true
                    ],
                    "datatype": "BOOLEAN"
                }
            ],
            "definitions": [
                process.env.REACT_APP_CATALOG_WORK_ORDERS
            ]
        }

        GetAllBySearchAction(model).then((r) => {
            const group = $("#work_order-grp")
            for (const item of r.data) {
                group.html("");
                let btn = '<div class="custom-control custom-radio">';
                btn +=
                    '<input type="radio" class="custom-control-input" name="performance"  id="' +
                    item["identification"] +
                    '" value="' +
                    item["identification"] +
                    '" />';
                btn +=
                    '<label class="custom-control-label" for="' +
                    item["identification"] +
                    '">' +
                    item["name"] +
                    "</label></div>";
                group.append(btn);
            }
        })
    }

    const handleSubmit = () => {
        $("#cover-spin").show(0);

        const element = $("input[name=performance]:checked");
        const performerId = element.attr("id");
        const model = {
            "werkorder": performerId
        }
        const activityId = "7492187b-a23f-4216-a303-69b8cb1e7535"
        const selected = GetSelected()
        StartActivityFlowAction(activityId, selected).then(()=>{
            InputDataActivityFlowAction(activityId, selected, model).then(() => {
                $("#performance_plaats_in_werkorder").modal("hide");
                window.$mm_performance_refresh();
            })
        })



        // GC.StartActivity(
        //     model,
        //     selectedIds,
        //     "7492187b-a23f-4216-a303-69b8cb1e7535",
        //     budgetVerplaatst,
        //     window.$mm_management_units_token
        // );
        //
        // function budgetVerplaatst() {
        //     GC.sleep(500).then(() => {
        //
        //         /*omnimap
        //           .FillTableAction(
        //             window.$mm_performance_lastUsedTableFilter,
        //             1,
        //             window.$mm_management_units_token
        //           )
        //           .then((result) => {
        //             CallBackFunctions.FillTableCallBack(result, 1);
        //           });*/
        //     });
        // }
    };

    return (
        <div
            className="modal fade"
            tabIndex={-1}
            role="dialog"
            id="performance_plaats_in_werkorder"
        >
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Plaats in werkorder</h5>
                        <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        />
                    </div>
                    <div className="modal-body">

                        <div className="modal-scroll">
                            <div id="work_order-grp" className="radio-grp"/>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            id="save_work_order"
                            className="btn-modal"
                            onClick={handleSubmit}
                        >
                            Verwerken
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PlaatsInWerkorder;
